var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightRgb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 38H18C18 38.855 18 40.4 18 40.4C18 43.714 20.686 46.4 24 46.4C27.314 46.4 30 43.714 30 40.4C30 40.4 30 38.855 30 38Z",
    fill: "#8D6E63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 9.25C30.4889 9.25 35.75 14.5111 35.75 21C35.75 24.4294 34.2807 27.3799 32.7835 29.9751C32.5594 30.3634 32.334 30.745 32.1129 31.1194C31.6001 31.9876 31.1102 32.8168 30.7144 33.5997C30.1476 34.7207 29.75 35.7892 29.75 36.8V37.75H18.25V36.8C18.25 35.7892 17.8524 34.7207 17.2856 33.5997C16.8898 32.8168 16.3999 31.9876 15.8871 31.1194C15.666 30.745 15.4406 30.3634 15.2165 29.9751C13.7193 27.3799 12.25 24.4294 12.25 21C12.25 14.5111 17.5111 9.25 24 9.25Z",
    fill: "white",
    stroke: "#B4B4B4",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightRgb);
export default __webpack_public_path__ + "static/media/light-rgb.640db4133ccd6ca787928b34643bf31d.svg";
export { ForwardRef as ReactComponent };